import React from 'react';
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import Gallery from "@/components/Gallery";
import SocialProof from "@/components/SocialProof";
import TestimonialsMarquee from "@/components/TestimonialsMarquee";
import ExperienceStrip from "@/components/ExperienceStrip";
import LocationSection from "@/components/LocationSection";
import FinalCTA from "@/components/FinalCTA";
import { STUDIO, galleryTattoo, galleryPiercing } from "@/lib/studio";

export default function Home() {
  const igStrip = [...galleryTattoo.slice(0, 4), ...galleryPiercing.slice(0, 4)];

  return (
   <div data-testid="home-page" className="scroll-smooth">
      <Hero />
      <SocialProof />
      
      <div id="what-we-do">
        <Services />
      </div>

      <div id="our-work">
        <Gallery />
      </div>

      <TestimonialsMarquee />
      <ExperienceStrip />

      <div id="contact" className="scroll-mt-20">
        <LocationSection />
      </div>

      {/* Instagram-style strip — our own photos, no third-party embed/watermark */}
      <section className="py-8 bg-black border-t border-white/5" data-testid="instagram-strip">
        <div className="max-w-7xl mx-auto px-5">
          <a
            href={`https://instagram.com/${STUDIO.instagram.replace("@", "")}`}
            target="_blank"
            rel="noopener noreferrer"
            className="block text-white/40 hover:text-white/70 font-medium tracking-[0.3em] text-[10px] uppercase mb-8 text-center transition-colors"
          >
            · Follow {STUDIO.instagram}
          </a>
          <div className="grid grid-cols-4 md:grid-cols-8 gap-2 md:gap-3">
            {igStrip.map((img, i) => (
              <a
                key={i}
                href={`https://instagram.com/${STUDIO.instagram.replace("@", "")}`}
                target="_blank"
                rel="noopener noreferrer"
                className="aspect-square overflow-hidden group"
              >
                <img
                  src={img}
                  alt="VOW Tattoo Studio on Instagram"
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-110"
                  loading="lazy"
                />
              </a>
            ))}
          </div>
        </div>
      </section>

      <FinalCTA />
    </div>
  );
}
